import { API_JWT_BASE_URL } from '../http'

export const GET_SETTINGS_API = `${API_JWT_BASE_URL}/admin/settings`
export const UPDATE_SETTINGS_API = `${API_JWT_BASE_URL}/admin/settings`
export const UPDATE_PPTOX_SSO_PROVISIONING_API = `${API_JWT_BASE_URL}/admin/Pttox/ssoConfiguration`
export const DISCONNECT_PPTOX_SERVER_API = `${API_JWT_BASE_URL}/admin/Pttox/disconnect`
export const SIGNING_CERTIFICATE_API = `${API_JWT_BASE_URL}/admin/Pttox/signingCertificate`

export const SETTINGS_QUERY_KEYS = {
  GET_SETTINGS: 'getSettings',
  UPDATE_SETTINGS: 'updateSettings',
  UPDATE_PPTOX_SSO_PROVISIONING: 'UPDATE_PPTOX_SSO_PROVISIONING',
  DISCONNECT_PPTOX_SERVER: 'DISCONNECT_PPTOX_SERVER',
  DOWNLOAD_CERTIFICATE_API: 'DOWNLOAD_CERTIFICATE_API',
  DELETE_CERTIFICATE_API: 'DELETE_CERTIFICATE_API',
  CREATE_CERTIFICATE_API: 'CREATE_CERTIFICATE_API'
}
